import { sendToApi } from 'api/client'
import { SUCCESS_RESPONSE_TYPE } from 'api/constants'
import { UseQueryOptions, useQuery } from 'react-query'
import { BrandVoice, Workspace, VoiceParams } from 'types'

export type { VoiceParams }

export type { BrandVoice as VoiceData }

export const useBrandVoices = (workspace: Workspace | undefined, options?: UseQueryOptions<BrandVoice[]>) => {
  return useQuery<BrandVoice[]>(
    ['workspaces', workspace?.id, 'brandVoices', 'list'],
    async () => {
      if (!workspace) return []
      const response = await sendToApi(`/w/${workspace.id}/brand_voices`)
      if (response.type === SUCCESS_RESPONSE_TYPE) {
        return response.data.brand_voices ?? []
      } else {
        throw new Error('Error fetching voices')
      }
    },
    {
      refetchOnWindowFocus: false,
      staleTime: (options?.cacheTime || 0) * 0.5,
      ...options,
    },
  )
}
